// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3QEPo","boxTitle":"Qualiphy_boxTitle__2HnIk","box":"Qualiphy_box__3gTMv","toggleWrap":"Qualiphy_toggleWrap__1b75P"};